import { combineReducers } from "redux"

import foodsReducer from "./foods"
import combosReducer from "./combos"
import tokenReducer from "./token"
import orderReducer from "./order"
import printersReducer from "./printers"
import deliveryInfoReducer from "./deliveryInfo"
import userAccountInfoReducer from "./userAccountInfo"
import systemSettingsReducer from "./systemSettings"
import ordersOfOrderPageReducer from "./ordersOfOrderPage"
import failedPrintsReducer from "./failedPrints"
import customerDisplaysReducer from "./customerDisplays"
import kitchenDisplaysReducer from "./kitchenDisplays"
import notViewedOrdersReducer from "./notViewedOrders"
import categoriesReducer from "./categories"
import internetStatusReducer from "./internetStatus"
import offlineOrdersReducer from "./offlineOrders"
import shiftCashierReducer from "./shiftCashier"
import kitchenTablesReducer from "./kitchenTables"
import orderForEditDetailsReducer from "./orderForEditDetails"
import pinModalReducer from "./pinModal"
import heldOrdersReducer from "./heldOrders"
import foodPageSidebarRefReducer from "./foodPageSidebarRef"
import failedOrdersReducer from "./failedOrders"
import warningPopupReducer from "./warningPopup"
import printRequestsReducer from "./printRequests"
import foodPageUiStateReducer from "./foodPageUiState"
import systemBranchesReducer from "./systemBranches"
import customerPrintTemplateReducer from "./customerPrintTemplate"
import groupedFoodIdsBasedOnCategoryReducer from "./groupedFoodIdsBasedOnCategory"
import contractDeactivationStatusReducer from "./contractDeactivationStatus"
import posTerminalsReducer from "./posTerminals"
import foodSpecificationsMapReducer from "./foodSpecificationsMap"
import foodTaxesMapReducer from "./foodTaxesMap"
import recommendedFoodsReducer from "./recommendedFoods"

const rootReducer = combineReducers({
  tokens: tokenReducer,
  order: orderReducer,
  foods: foodsReducer,
  combos: combosReducer,
  userAccountInfo: userAccountInfoReducer,
  systemSettings: systemSettingsReducer,
  deliveryInfo: deliveryInfoReducer,
  ordersOfOrderPage: ordersOfOrderPageReducer,
  printers: printersReducer,
  categories: categoriesReducer,
  notViewedOrders: notViewedOrdersReducer,
  failedPrints: failedPrintsReducer,
  customerDisplays: customerDisplaysReducer,
  kitchenDisplays: kitchenDisplaysReducer,
  internetStatus: internetStatusReducer,
  offlineOrders: offlineOrdersReducer,
  shiftCashier: shiftCashierReducer,
  orderForEditDetails: orderForEditDetailsReducer,
  kitchenTables: kitchenTablesReducer,
  pinModal: pinModalReducer,
  heldOrders: heldOrdersReducer,
  failedOrders: failedOrdersReducer,
  foodPageSidebarRef: foodPageSidebarRefReducer,
  warningPopup: warningPopupReducer,
  printRequests: printRequestsReducer,
  foodPageUiState: foodPageUiStateReducer,
  systemBranches: systemBranchesReducer,
  customerPrintTemplate: customerPrintTemplateReducer,
  groupedFoodIdsBasedOnCategory: groupedFoodIdsBasedOnCategoryReducer,
  contractDeactivationStatus: contractDeactivationStatusReducer,
  posTerminals: posTerminalsReducer,
  foodSpecificationsMap: foodSpecificationsMapReducer,
  foodTaxesMap: foodTaxesMapReducer,
  recommendedFoods: recommendedFoodsReducer
})

export default rootReducer